import { uniqBy } from "lodash";
import { helpers } from "../../common/lib";
import getInitialState from "../get-initial-state";
import { actionTypes } from "./actions";

const initialState = {
    identifier1: "",
    identifier2: "",
    internalReference: "",
    make: "",
    model: ""
};

export default function (state = { ...initialState }, action) {
    switch (action.type) {
        case actionTypes.ASSET_LOOKUP_CLEAR: {
            return { ...initialState };
        }
        case actionTypes.ASSET_LOOKUP_POST_SUCCESS: {
            const { data } = action.payload;
            return { ...data };
        }
        default: {
            return state;
        }
    }
}
